import { Modal } from "bootstrap";
import Cookies from "js-cookie";

import { EventBus } from "./event_bus.js";
import { MessageBus } from "./message_bus.js";
import { Utils } from "./utils.js";
import { APP } from "./app.js";

export class TimedComment {
  #modalElement
  #form
  #submitButton
  #pauseRecordingCheck
  #timerDisplay
  #errorElement

  #modal
  #secondAtFormatted

  constructor() {
    this.#modalElement = document.querySelector("#timed-comment-modal");
    this.#form = document.querySelector("#timed-comment-form");
    this.#submitButton = this.#form.querySelector("button[type=submit]");
    this.#pauseRecordingCheck = document.querySelector("#timed-comment-pause-recording-check");
    this.#timerDisplay = document.querySelector("#timed-comment-timer-display");
    this.#errorElement = document.querySelector("#timed-comment-error");

    this.#modal = new Modal(this.#modalElement, {});

    this.#setEvents();
    this.#checkIfPauseRecordingChecked();
    this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();
  }

  async #setEvents() {
    this.#form.addEventListener("submit", (event) => {
      this.#formSend(event);
    });

    this.#pauseRecordingCheck.addEventListener("change", (event) => {
      this.#togglePauseRecording(this.#pauseRecordingCheck.checked);
    });

    this.#form.querySelector("#timed-comment-comment").addEventListener("input", (event) => {
      this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();
    });

    this.#modalElement.addEventListener('hidden.bs.modal', event => {
      this.#modalClosed();
    });

    this.#modalElement.addEventListener('show.bs.modal', event => {
      this.#modalOpened();
    });
  }

  // The comment is about the moment the tester opened it, not the moment it
  // was sent (A19)
  #modalOpened() {
    this.#secondAtFormatted = APP.recordingManager.timer.timeToString();
    this.#timerDisplay.textContent = this.#secondAtFormatted;
    this.#hideError();

    this.#togglePauseRecording(this.#pauseRecordingCheck.checked);
  }

  #modalClosed() {
    if (this.#pauseRecordingCheck.checked) {
      EventBus.event("timed-comment-toggle-recording-pause", false);
    }
  }

  #closeModal() {
    this.#modal.hide();
  }

  #disableSubmitButton() {
    this.#submitButton.setAttribute("disabled", true);
  }

  #enableSubmitButton() {
    this.#submitButton.removeAttribute("disabled");
  }

  // A send error is shown inside the modal, not in a second modal on top of
  // it (A30), and the form stays usable
  async #formSend(event) {
    MessageBus.debug("TimedCommentFormSend :: ini");
    event.preventDefault();

    this.#disableSubmitButton();
    this.#hideError();

    const flair = this.#form.querySelector("input[name=flair]:checked").value;
    const comment = this.#form.querySelector("#timed-comment-comment").value;

    try {
      await APP.playcocolaAPI.sendTimedComment(this.#secondAtFormatted, flair, comment);
      MessageBus.debug("TimedCommentFormSend :: end");
      this.#closeModal();
      this.#form.querySelector("#timed-comment-comment").value = "";
    } catch (error) {
      console.error("TimedCommentFormSend :: error", error);
      MessageBus.debug("TimedCommentFormSend :: error: " + Utils.normalizeError(error).message);
      this.#showError("Your comment could not be sent. Please check your connection and try again.");
    } finally {
      this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();
    }
  }

  #showError(message) {
    this.#errorElement.textContent = message;
    this.#errorElement.classList.remove("d-none");
  }

  #hideError() {
    this.#errorElement.classList.add("d-none");
    this.#errorElement.textContent = "";
  }

  #checkIfPauseRecordingChecked() {
    this.#pauseRecordingCheck.checked = (Cookies.get("pause-recording-while-commenting") == "true")
  }

  #togglePauseRecording(value) {
    Cookies.set("pause-recording-while-commenting", value);
    EventBus.event("timed-comment-toggle-recording-pause", value);
  }

  #checkIfSubmitButtonShouldBeEnabledOrDisabled() {
    let result = this.#form.querySelector("#timed-comment-comment").value.trim() !== "";

    if (result) {
      this.#enableSubmitButton();
    } else {
      this.#disableSubmitButton();
    }
  }
}
